import { render, staticRenderFns } from "./FeaturedLogos.vue?vue&type=template&id=5fc9623a&scoped=true&"
import script from "./FeaturedLogos.vue?vue&type=script&lang=js&"
export * from "./FeaturedLogos.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedLogos.vue?vue&type=style&index=0&id=5fc9623a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc9623a",
  null
  
)

export default component.exports